import styled from "styled-components";
import { FlexColumn, FlexRow, FlexRowDiv } from "../common.styles";
import { HXMobilePageWithFixedHeaderAndFooterContainer, HXMobilePageWithFixedHeaderAndFooterContent } from "../HXMobilePage.styles";
import { colors } from "healthex-common/colors";
import { HXButton } from "../HXButton";
import { HXTextField } from "../base.styles";
import { FileUploadView } from "../FileUploadView";
import CheckCircle from "@mui/icons-material/CheckCircleOutline";
import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined";
import { Subtitle, Text } from "../HXDesktopPage.styles";
import { fontSizes } from "healthex-common/sizes";
import { FormSection } from "./AddJoinCommonComponents.styles";
export const RequirementsWizardParent = styled(HXMobilePageWithFixedHeaderAndFooterContainer).attrs({
    overflowYHidden: false,
}) ``;
export const RequirementsWizardContent = styled(HXMobilePageWithFixedHeaderAndFooterContent).attrs({
    isHeaderAndFooterFixed: true,
}) `
    flex: 1 0 0;
    padding: 0 24px 20px 24px;
`;
export const RequirementsFooterContainer = styled(FlexRowDiv) `
    padding: 16px 24px;
    border-top: 1px solid ${colors.black_12};
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`;
const statusColors = {
    success: {
        border: colors.forest_main,
        background: colors.forest_8,
    },
    warning: {
        border: colors.sunset_main,
        background: colors.sunset_8,
    },
    info: {
        border: colors.navy_main,
        background: colors.navy_8,
    },
    failed: {
        border: colors.sunset_main,
        background: colors.sunset_8,
    },
    default: {
        border: colors.navy_main,
        background: colors.navy_8,
    },
};
export const SuccessIcon = styled(CheckCircle) `
    width: 24px;
    height: 24px;
    color: ${colors.forest_main};
`;
export const WarningIcon = styled(WarningAmberOutlined) `
    width: 24px;
    height: 24px;
    color: ${colors.sunset_main};
`;
export const RequirementsBannerContainer = styled(FlexRow) `
    gap: 8px;
    padding: 16px;
    align-self: stretch;
    align-items: center;
    border-radius: 4px;
    border: 1px solid ${({ status }) => statusColors[status !== null && status !== void 0 ? status : "default"].border};
    background: ${({ status }) => statusColors[status !== null && status !== void 0 ? status : "default"].background};
`;
export const RequirementsTextField = styled(HXTextField) `
    align-self: stretch;
`;
export const RequirementsNextButton = styled(HXButton) `
    align-self: stretch;
    min-width: 86.516px;
`;
export const RequirementsSuccessList = styled.ol `
    padding: 0 0 0 20px;
    margin: 0;
`;
export const RequirementsProtocolUploadView = styled(FileUploadView) `
    width: 100%;
`;
export const RequirementsContentSectionWrapper = styled(FlexColumn) `
    gap: 16px;
    padding: 24px;
`;
export const EditRequirementsSection = styled(FlexColumn) `
    padding: 16px;
    gap: 16px;
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
`;
export const EditRequirementsSectionTitle = styled(Subtitle) `
    font-size: ${fontSizes.MEDIUM};
`;
export const EditRequirementsSectionFormSection = styled(FormSection) `
    gap: 16px;
`;
export const EditRequirementsSectionRadioButtonExtraText = styled(Text) `
    margin-left: 42px;

    &:hover {
        cursor: pointer;
    }
`;
